import { omit } from 'lodash';
import { GET_SCHEDA_PERSONA_ESISTENTE_VIEWLET, RESET_SCHEDA_PERSONA_ESISTENTE_VIEWLET } from 'uniba-volto-persone/actions';


const initialState = {
    error: null,
    items: [],
    total: 0,
    loaded: false,
    loading: false,
    batching: {},
    subrequests: {},
};

/**
 * querystringsearch reducer.
 * @function querystring
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export function schedaPersonaEsistenteViewletReducer(state = initialState, action = {}) {
    switch (action.type) {
        case RESET_SCHEDA_PERSONA_ESISTENTE_VIEWLET:
            return action.subrequest
                ? {
                    ...state,
                    subrequests: {
                        ...state.subrequests,
                        [action.subrequest]: {
                            error: null,
                            items: {
                                ...state.subrequest[action.subrequest]?.items,
                                [action.user_id]: {}
                            },
                            total: 0,
                            loaded: true,
                            loading: false,
                            batching: {},
                        },
                    },
                }
                : {
                    ...state,
                    error: null,
                    items: {
                        ...state.items, 
                        [action.user_id]: {}
                    },
                    total: 0,
                    loaded: true,
                    loading: false,
                    batching: {},
                };
        case `${GET_SCHEDA_PERSONA_ESISTENTE_VIEWLET}_PENDING`:
            return action.subrequest
                ? {
                    ...state,
                    subrequests: {
                        ...state.subrequests,
                        [action.subrequest]: {
                            ...(state.subrequests[action.subrequest] || {
                                items: [],
                                total: 0,
                                batching: {},
                            }),
                            error: null,
                            loaded: false,
                            loading: true,
                        },
                    },
                }
                : {
                    ...state,
                    error: null,
                    loading: true,
                    loaded: false,
                };
        case `${GET_SCHEDA_PERSONA_ESISTENTE_VIEWLET}_SUCCESS`:
            return action.subrequest
                ? {
                    ...state,
                    subrequests: {
                        ...state.subrequests,
                        [action.subrequest]: {
                            error: null,
                            items: {
                                ...state.subrequest[action.subrequest]?.items,
                                [action.user_id]: action.result
                            },
                            total: action.result.length,
                            loaded: true,
                            loading: false,
                            batching: { ...action.result.batching },
                        },
                    },
                }
                : {
                    ...state,
                    error: null,
                    items: {
                        ...state.items, 
                        [action.user_id]: action.result
                    },
                    total: action.result.length,
                    loaded: true,
                    loading: false,
                    batching: { ...action.result.batching },
                };
        case `${GET_SCHEDA_PERSONA_ESISTENTE_VIEWLET}_FAIL`:
            return action.subrequest
                ? {
                    ...state,
                    subrequests: {
                        ...state.subrequests,
                        [action.subrequest]: {
                            error: action.error,
                            items: [],
                            total: 0,
                            loading: false,
                            loaded: false,
                            batching: {},
                        },
                    },
                }
                : {
                    ...state,
                    error: action.error,
                    items: [],
                    total: 0,
                    loading: false,
                    loaded: false,
                    batching: {},
                };
        default:
            return state;
    }
}
